import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { CommonService } from 'src/app/services/common.service';
import { companyReportData } from 'src/environments/environment';

@Component({
  selector: 'app-primitive-maintanance',
  templateUrl: './primitive-maintanance.component.html',
  styleUrls: ['./primitive-maintanance.component.scss'],
})
export class PrimitiveMaintananceComponent implements OnInit {
  displayData;
  constructor(
    private commonService: CommonService,
    private platform: Platform
  ) { }
  createPdf() {
    var obj = [];
    for (let i = 0; i < this.displayData.length; i++) {
      obj.push([this.displayData[i].plateno, this.displayData[i].currentOdometer, this.displayData[i].lastmaintenance,
      this.displayData[i].lastmaintenancetime, this.displayData[i].duekilometer, this.displayData[i].status])
    }
    this.commonService.downloadPdfReports(['Plate No', "Odometer", "Last maintanance", "Last maintenance time", "Due kilometer", "Status"], obj, "Primitive maintanance report")
  }
  ngOnInit() {
    this.commonService.dismissLoader()
    this.displayData = companyReportData.reportData
  }

}
